import {Button, Overlay, Popover, Stack} from "react-bootstrap";
import React, {forwardRef, useImperativeHandle, useRef, useState} from "react";
import {Editor} from 'react-draft-wysiwyg';
import {stateToHTML} from 'draft-js-export-html';
import style from "./ComposeNotification.module.css";
import moreTextBlockStyle from './MoreTextBlock.module.css'
import editor from "../../Style/EditorStyle.module.css";
import button from "../../Style/ButtonStyle.module.css";
import htmlToDraft from "html-to-draftjs";
import {ContentState, convertFromRaw, convertToRaw, EditorState, Modifier} from "draft-js";
const MoreTextBlock=forwardRef((props: any,ref: any)=>{
    const [show, setShow] = useState(props?.show);
    const [target, setTarget] = useState(document.getElementById("MoreTextBlockShowButton"));
    const [editorState, setEditorState]=useState(props?.moreTextBlockEditorState?props?.moreTextBlockEditorState:null);
    const [plainTextLength, setPlainTextLength]=useState(0);
    const MAX_LENGTH = 1000;
    //const ref = useRef(props.ref);
    const handleClick = (event: any) => {
        console.log(event);
        let l = props?.getCurrentContentLength();
        console.log("content length",l);
        setEditorState(EditorState.createEmpty());
        if((window as any).moretextToBeEdited){
            const contentBlock = htmlToDraft((window as any).moretextToBeEdited);
            //const contentBlock = htmlToDraft("Hello World!");
            let contentState1 = ContentState.createFromBlockArray(contentBlock.contentBlocks);
            setEditorState(EditorState.createWithContent(contentState1))
        }
        setShow(!show);
        setTarget(event.target);
    };

    const onEditorStateChange=(editorState)=>{

        setPlainTextLength(editorState.getCurrentContent().getPlainText().replace('\n','').trim().length);
        setEditorState(editorState);

    }

    const insertInMainEditorAsHTML=()=>{
        let contentState = editorState.getCurrentContent();
        let html = stateToHTML(contentState, {});
        let rawState= convertToRaw(contentState);
        console.log("MoreTextBLock - Saving html ",html);
        props.addMoreTextInEditor({html:html,raw:rawState});
        setShow(false);
        setEditorState(false);
    }

    const cleanPaste = (html) =>{
        if (!html || typeof html !== 'string') return '';

        // Remove additional MS Word content
        html = html.replace(/<(\/)*(\\?xml:|meta|link|html|body|head|span|font|del|ins|st1:|[ovwxp]:)((.|\s)*?)>/gi, ''); // Unwanted tags
        html = html.replace(/(class|style|type|start)=("(.*?)"|(\w*))/gi, ''); // Unwanted sttributes
        html = html.replace(/<style(.*?)style>/gi, '');   // Style tags
        html = html.replace(/<script(.*?)script>/gi, ''); // Script tags
        html = html.replace(/<!--(.*?)-->/gi, '');        // HTML comments

        return html;
    }
    const _handlePastedText = (text, html, editorState) => {
        const selection = editorState.getSelection();
        // When pasting plain text, html is undefined — wrap the text in a <p> so htmlToDraft can parse it.
        const rawHtml = html || (text ? `<p>${text}</p>` : '');
        const cleanedHtml = cleanPaste(rawHtml);
        if (!cleanedHtml) return 'not-handled';
        const contentBlock = htmlToDraft(cleanedHtml);
        if (!contentBlock || !contentBlock.contentBlocks || contentBlock.contentBlocks.length === 0) return 'not-handled';
        const pastedBlocks = ContentState.createFromBlockArray(contentBlock.contentBlocks, contentBlock.entityMap).getBlockMap();
        const newState = Modifier.replaceWithFragment(
            editorState.getCurrentContent(),
            editorState.getSelection(),
            pastedBlocks,
        );
        const newEditorState = EditorState.push(editorState, newState, "insert-fragment");
        onEditorStateChange(newEditorState);
        console.log("pasting done....");
        return "handled";
    };
    useImperativeHandle(ref, () => ({
        openMoreTextBlockEditor(text) {
            console.log("test now lskdf");
            setShow(true);
            setTarget(document.getElementById("MoreTextBlockShowButton"));
        }
    }),[editorState]);

    return (
        <div ref={ref} style={{display:'flex'}}>
            <button id="MoreTextBlockShowButton" onClick={handleClick} type="button" className={style.iconclass} title="Add More Text">
                <span className={editor.fileTextSvgIcon}></span>
            </button>
            <Overlay
                show={show}
                target={target}
                placement="top-start"
                container={ref}
                containerPadding={20}
                rootClose={true}
                onHide={handleClick}
            >
                <Popover id="popover-contained" style={{borderRadius:'10px'}} >
                    <Popover.Body style={{padding:"10px",borderRadius:'10px', width:"510px"}} >
                        { props.getCurrentContentLength() > 0 ? <Editor
                           editorState={editorState}
                           onEditorStateChange={onEditorStateChange}
                           handlePastedText={_handlePastedText}
                           editorClassName={moreTextBlockStyle.CustomStyle}
                            placeholder="Insert your additional text here..."
                           toolbar={{
                               options: ['inline', 'list', 'link'],
                               inline: {
                                   options: ['bold', 'italic', 'underline'],
                                   bold: {className: 'bordered-option-classname'},
                                   italic: {className: 'bordered-option-classname'},
                                   underline: {className: 'bordered-option-classname'},
                                   inDropdown: false,
                               },
                               list: {
                                   inDropdown: false,
                                   className: undefined,
                                   component: undefined,
                                   dropdownClassName: undefined,
                                   options: ['unordered', 'ordered'],

                               },
                               link: {
                                   inDropdown: false,
                                   className: undefined,
                                   component: undefined,
                                   popupClassName: undefined,
                                   dropdownClassName: undefined,
                                   showOpenOptionOnHover: true,
                                   defaultTargetOption: '_self',
                                   options: ['link', 'unlink'],
                                   linkCallback: undefined
                               },
                               blockType: {
                                   className: 'bordered-option-classname',
                               },
                               fontSize: {
                                   className: 'bordered-option-classname',
                               },
                               fontFamily: {
                                   className: 'bordered-option-classname',
                               },
                           }}

                       />: <div style={{padding:"10px",borderRadius:'10px',textAlign:'center', color:"#e13838"}}>First add text to the primary text box. Use this for additional text. </div>}
                        {plainTextLength > MAX_LENGTH && (
                            <div style={{padding:"4px 10px 0", color:"#e13838", fontSize:"12px"}}>
                                Content exceeded the allowed length of {MAX_LENGTH} characters.
                            </div>
                        )}
                        <div style={{padding:"10px",borderTop:"1px solid #ccc"}}>
                            <Stack direction="horizontal" className="justify-content-md-end" gap={1}>
                                <span style={{fontSize:'12px', color: plainTextLength > MAX_LENGTH ? '#e13838' : plainTextLength > MAX_LENGTH * 0.9 ? '#e67e22' : '#888', marginRight:'auto'}}>
                                    {plainTextLength}/{MAX_LENGTH}
                                </span>
                                <Button  size="sm" variant="secondary" onClick={handleClick}>Cancel</Button>
                                { props.getCurrentContentLength() > 0? <Button disabled={plainTextLength<1 || plainTextLength>MAX_LENGTH}  size="sm" variant="primary" onClick={insertInMainEditorAsHTML}>Save</Button>:null}
                            </Stack>
                        </div>
                    </Popover.Body>

                </Popover>
            </Overlay>
        </div>
    );

});

export default MoreTextBlock;
